import {
  Dispatch, JSX, SetStateAction, useState,
} from 'react';
import { IBiomaterial, IBiomaterialFilters } from '@zero-dash/types';
import BiomaterialsFilterButton from './BiomaterialsFilterButton';
import BiomaterialsTableMoreOptionsButton from './BiomaterialsTableMoreOptionsButton';
import SearchFilterBar from '@/components/SearchFilterBar/SearchFilterBar';
import Search from '@/components/Search/Search';
import { IBiomaterialRow } from '@/types/PatientDashboard/TimelineView.types';

interface IProps {
  biomaterials: IBiomaterial[];
  rows: IBiomaterialRow[];
  toggled: IBiomaterialFilters;
  setToggled: Dispatch<SetStateAction<IBiomaterialFilters>>;
  emptyOptions: IBiomaterialFilters;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  searchMethod: (query: string) => void;
  counts?: {current: number, total: number};
  showSubmissions?: boolean;
  onToggleSubmissions?: () => void;
}

export default function PatientSearchFilterBar({
  biomaterials,
  rows,
  toggled,
  setToggled,
  emptyOptions,
  loading,
  setLoading,
  searchMethod,
  counts,
  showSubmissions = false,
  onToggleSubmissions,
}: IProps): JSX.Element {
  const [searchValue, setSearchValue] = useState<string>('');

  const resetAll = (): void => {
    setToggled(emptyOptions);
    setSearchValue('');
  };

  const checkFilters = (): boolean => (
    JSON.stringify(toggled) !== JSON.stringify(emptyOptions)
  );

  return (
    <SearchFilterBar
      dashboard
      isDefault={!(checkFilters() || (toggled.sortColumns?.length || 0) !== 0)}
      resetToDefault={!showSubmissions ? resetAll : undefined}
      counts={!showSubmissions ? counts : undefined}
      search={!showSubmissions && (
        <Search
          searchMethod={searchMethod}
          searchOnChange={false}
          advancedSearch
          supportedFields="Biomaterial name, Biomaterial ID"
          value={searchValue}
          setValue={setSearchValue}
          placeholder={searchValue ? 'Click to view full query' : 'Search'}
        />
      )}
      afterCounts={onToggleSubmissions && (
        <BiomaterialsTableMoreOptionsButton
          rows={rows}
          showSubmissions={showSubmissions}
          onToggleSubmissions={onToggleSubmissions}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    >
      {!showSubmissions && (
        <BiomaterialsFilterButton
          biomaterials={biomaterials}
          toggled={toggled}
          setToggled={setToggled}
          emptyOptions={emptyOptions}
          loading={loading}
          setLoading={setLoading}
          setSearchValue={setSearchValue}
        />
      )}
    </SearchFilterBar>
  );
}
